import React from 'react';
import './QuizResultsProgressbar.css';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';

interface QuizResultsProgressbarProps {
    total: number
    totalCorrect: number
    minCorrect: number
}

const QuizResultsProgressbar: React.FC<QuizResultsProgressbarProps> = ({total, totalCorrect, minCorrect}) => {
    const passed = totalCorrect >= minCorrect;
    
    return (
        <div className="progressbar-container">
            <CircularProgressbarWithChildren
                value={total > 0 ? totalCorrect/total : 0}
                maxValue={1}
                strokeWidth={12}
                styles={buildStyles({
                    strokeLinecap: "butt",
                    pathColor: passed ? "#00bbff" : "#ff6b6b",
                    trailColor: "rgba(0, 187, 255, 0.1)"
                  })}
                >
                <div className="progressbar-content">
                    <div className="progressbar-content-title">
                        {totalCorrect}
                    </div>
                    <div className="progressbar-content-subtitle">
                        ud af {total}
                    </div>
                </div>
            </CircularProgressbarWithChildren>
        </div>
    );
}

export default QuizResultsProgressbar;
